
















































































































import { ScrollButton } from "wings-ui-components";
import CallDetailIncomingFilter from "@/components/Call/Statistic/CallDetailIncomingFilter.vue";
import { DetailIncomingItem } from "@/store/call/statistic/types";
import { dateFilter } from "@/utils/date-util";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import BaseItemsPage from "../BaseItemsPage";
import { colorClassByStatus } from "@/utils/page-utils";

@Component({
  components: {CallDetailIncomingFilter, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class CallDetailIncoming extends BaseItemsPage<DetailIncomingItem> {

  @Getter("callStatisticDetailIncoming") responseItems?: DetailIncomingItem[];

  is_show_filter: boolean = true;
  currentSort: string = "create_date";

  tableFields: string[] = this.tableFieldsDefault;

  get tableFieldsDefault(): string[] {
    return [
      'id', 'create_date', 'originator', 'recipient',
      'partner', 'content', 'status', 'error_code', 'detail',
    ];
  }

  getData(): DetailIncomingItem[] | undefined {
    return this.responseItems;
  }
}
